import axios from 'axios';

export const createTenant = async (tenant) => {
  const url = `${process.env.REACT_APP_API_URL}/tenants`
  const headers = {
    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    'Content-Type': 'application/json'
  };
  try {
    const response = await axios.post(url,{...tenant},{headers: headers});
    return response;
  } catch (error) {
    const {response} = error;
    return response;
  }
}


